import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import queryString from 'query-string';
import { Googletag } from 'shared/modules';
import cx from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import Link from 'shared/components/Link/Link';
import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';
import { DEALER_TABS } from 'shared/constants/navigation';
// import CarsList from 'desktop/components/CarsList/CarsList';
import CarsLeasingList from 'desktop/components/CarsLeasingList/CarsLeasingList';
import Paginate from 'desktop/components/Paginate/Paginate';
import About from 'shared/components/About';
import * as formActions from 'shared/actions/searchForm';
import { toLocalized } from 'shared/helpers/locale';
import withDealerGAEvent from 'shared/hocs/stats/withDealerGAEvent';
import CanonicalLinks from 'desktop/components/CanonicalLinks/CanonicalLinks';
import MakesSidebar from '../../components/MakesSidebar/MakesSidebar';
import TabButtons from '../../components/TabButtons/TabButtons';
import SearchBar from './components/SearchBar';
import DealerInfo from './components/DealerInfo/DealerInfo';
import NewsAndPromotions from './components/NewsAndPromotions/NewsAndPromotions';
import DealerImages from './components/DealerImages/DealerImages';
// import Makes from './components/Makes/Makes';
import SortLine from './components/SortLine';
import history from '../../../history';
import s from './Dealer.css';
import { generateDealersSearchUrl } from '../../../shared/helpers/urls';

class Dealer extends React.Component {
  static propTypes = {
    dealerInfo: PropTypes.shape().isRequired,
    currentPage: PropTypes.number,
    tab: PropTypes.string,
    url: PropTypes.string.isRequired,
    formData: PropTypes.shape().isRequired,
    query: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    carsResult: PropTypes.shape().isRequired,
    transportType: PropTypes.shape().isRequired,
    dealersTypes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    carsListTypes: PropTypes.shape().isRequired,
    location: PropTypes.shape(),
    // News
    news: PropTypes.arrayOf(PropTypes.shape()),
    newsPage: PropTypes.number,
    newsPageCount: PropTypes.number,
    isMotoSearch: PropTypes.bool,
    isCommercial: PropTypes.bool,
    canonicalList: PropTypes.arrayOf(PropTypes.shape()),
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    tab: 'offers',
    news: null,
    location: null,
    newsPage: 0,
    currentPage: null,
    newsPageCount: 0,
    isCommercial: false,
    isMotoSearch: false,
    canonicalList: [],
  };

  selectMake = make => {
    const { dealerInfo, selectedActions, intl } = this.props;

    const pathname = toLocalized(`/avtosalony/${dealerInfo.slug}/`, intl.locale);
    const { search } = history.location;
    const query = queryString.parse(search);
    selectedActions.set.make(make);
    const q = { ...query, make: make.id };
    const url = `${pathname}?${queryString.stringify(q)}`;

    history.push(url);
  };

  render() {
    const {
      transportType,
      carsListTypes,
      formState,
      formData,
      formVocabulary,
      carsResult,
      currentPage,
      tab,
      dealerInfo,
      dealersTypes,
      query,
      url,
      intl,
      // News
      news,
      newsPage,
      newsPageCount,
      isMotoSearch,
      isCommercial,
      selectedActions,
      canonicalList,
    } = this.props;

    const {
      photos,
      description,
      makes = [],
      slug,
      models,
      worktime,
      adverts_count: advertsCount = 0,
      official_make: officialMake,
      location,
      ...info
    } = dealerInfo;

    const carsResults = {};
    Object.keys(carsListTypes).forEach(key => {
      carsResults[key] = carsResult && carsResult[key];
    });

    const { result } = carsResults || {};

    const count = result && result.count ? result.count : 0;
    const pageCount = Math.ceil(count / 20);
    const title = dealerInfo.title;

    const breadcrumbs = [
      {
        link: `/${generateDealersSearchUrl({})}/`,
        title: intl.formatMessage({ id: 'Автосалоны' }),
      },
      {
        link: `/${generateDealersSearchUrl({ location })}`,
        title: location && location.title,
      },
    ].filter(item => item.link && item.title);

    const tabButtons = [
      {
        title: intl.formatMessage({ id: 'Предложения' }),
        tab: DEALER_TABS.OFFERS,
        slug: null,
        badge: advertsCount,
      },
      {
        title: intl.formatMessage({ id: 'Новости и Акции' }),
        tab: DEALER_TABS.BLOG,
        slug: DEALER_TABS.BLOG,
      },
      {
        title: intl.formatMessage({ id: 'О компании' }),
        tab: DEALER_TABS.ABOUT,
        slug: DEALER_TABS.ABOUT,
      },
    ];

    const pathname = `avtosalony/${slug}`;
    const canonicals = canonicalList.map(item => ({
      ...item,
      slug: '',
      rel: 'nofollow',
      params: { make: item.id },
    }));
    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <Breadcrumbs links={breadcrumbs} />
              <DealerInfo schedule={worktime} makes={makes} slug={slug} {...info}>
                {photos && photos.length > 0 && <DealerImages photos={photos} />}
                <TabButtons pathname={pathname} buttons={tabButtons} activeTab={tab} />
              </DealerInfo>

              {tab === DEALER_TABS.OFFERS &&
                <div>
                  {dealersTypes &&
                    dealersTypes.length > 1 &&
                    <div className={s.navWrapper}>
                      <ul className={s.list}>
                        {dealersTypes.map(type =>
                          <li
                            key={type.id}
                            className={cx(s.item, {
                              [s.active]: type.id === transportType.id,
                            })}
                          >
                            {type.id === transportType.id &&
                              <span className={s.link}>
                                {type.title}
                              </span>}
                            {type.id !== transportType.id &&
                              <Link to={`/${pathname}/?transport=${type.id}`} className={s.link}>
                                {type.title}
                              </Link>}
                          </li>,
                        )}
                      </ul>
                    </div>}
                  <SearchBar
                    transportType={transportType}
                    pathname={`${pathname}/`}
                    count={count}
                    selectedActions={selectedActions}
                    formState={formState}
                    formData={formData}
                    formVocabulary={formVocabulary}
                    isMotoSearch={isMotoSearch}
                    isCommercial={isCommercial}
                  />
                  <div className={s.header}>
                    {makes &&
                      makes.length > 0 &&
                      <CanonicalLinks
                        key={transportType.id}
                        canonicalList={canonicals}
                        linkPrefix={pathname}
                      />}
                  </div>
                  <div className={s.advertContainer}>
                    <Googletag id="div-gpt-ad-1510239331518-2" />
                  </div>
                  <SortLine
                    formVocabulary={formVocabulary}
                    formState={formState}
                    pathname={`${pathname}/`}
                    selectedActions={selectedActions}
                  />
                  {/* <CarsList currentPage={currentPage || 1} cars={result ? result.results : []} /> */}
                  <CarsLeasingList currentPage={currentPage || 1} cars={result ? result.results : []} />
                  <Paginate
                    query={query}
                    url={url}
                    pageCount={pageCount}
                    initialPage={currentPage || 1}
                  />
                </div>}

              {tab === DEALER_TABS.BLOG &&
                <NewsAndPromotions
                  title={title}
                  news={news}
                  page={newsPage}
                  pageCount={newsPageCount}
                  url={url}
                  query={query}
                />}
              {tab === DEALER_TABS.ABOUT && <About title={title} content={description} />}
            </div>
            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formState: state.searchForm.selected,
  // formResults: state.searchForm.results,
  formData: state.searchForm.data,
  formVocabulary: state.searchForm.vocabulary,
});

const utilActions = dispatch => ({
  toggle: bindActionCreators(formActions.selectedActions.toggle, dispatch),
  clear: bindActionCreators(formActions.selectedActions.clear),
  clearForm: bindActionCreators(formActions.carSetThunks.clearSelected, dispatch),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...(() => {
          if (ownProps.isCommercial) {
            return formActions.commercialSetThunks;
          }
          if (ownProps.isMotoSearch) {
            return formActions.motoSetThunks;
          }

          return formActions.carSetThunks;
        })(),
      },
      dispatch,
    ),
    ...utilActions(dispatch),
  },
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(withDealerGAEvent(Dealer))),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/Dealer.js